webpackJsonp([12],{

/***/ 1064:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userProfile3_vue__ = __webpack_require__(1116);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cbc951e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userProfile3_vue__ = __webpack_require__(1214);
function injectStyle (ssrContext) {
  __webpack_require__(1212)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cbc951e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userProfile3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cbc951e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userProfile3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_storage_service__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      Genres: [],
      Languages: [],
      Events: [],
      Sports: [],
      userDetails: [],
      _userDetails: [],
      genderOptions: [{ text: "Male", value: "1" }, { text: "Female", value: "0" }],
      CountryCodeList: [],
      errorMessage: "",
      successMessage: "",
      message: "",
      moviesData: ["Urban", "Thriller", "Speculative", "Slice", "Of", "Life", "Science-Fiction", "Satire", "Saga", "Romance", "Philosophical", "Paranoid", "Musical", "Mystery", "Horror", "Historical", "Fantasy", "Family", "Erotica", "Documentary", "Drama", "Crime", "Comedy", "Biography", "Animation", "Adventure", "Action"],
      eventsData: ["Class", "Seminar", "Sales and Marketing", "Finance", "StartUps", "Educators", "Dance", "Music", "Dinning and Music Concerts", " Food and Drink", " Exhibitions"],
      langugageData: ["English", "Philipino", "Kannada", "Arabic", "Oriya", "Malayalam", "Punjabi", "Chinese", "Hindi (Dubbed)", "Norweaian", "Thai", "Tamil"]
    };
  },
  beforeMount: function beforeMount() {
    this.getMyPref();
    this.fetchUserDetails();
    this.getAllGetCountryList();
  },

  methods: {
    getAllGetCountryList: function getAllGetCountryList() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/GetCountryCode", "POST", null, {}).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this.CountryCodeList = res.data.List;
          _this.userDetails.CountryCode = res.data.Default.CountryCode;
          _this.defaultCountryCode = res.data.Default.CountryCode;
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    onChangeCountry: function onChangeCountry(country) {
      console.log("country :", country);
      this.defaultCountryCode = country.CountryISOCode;
    },
    fetchUserDetails: function fetchUserDetails() {
      var _this2 = this;

      var token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/GetProfile", "POST", token, null).then(function (result) {
        _this2.userDetails = result.res.data;
        // this._userDetails = result.res.data;
        // this.message = this.userDetails.ReferalCodeURL;
        // this.referralHistory = this.userDetails.userreflegdata
        //   ? this.userDetails.userreflegdata
        //   : [];
        // console.log("URL", this.referralHistory);
      }).catch(function (error) {
        console.log(" Error", error);
      });
    },
    onUpdateProfile: function onUpdateProfile() {
      var _this3 = this;

      var token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
      var payload = {
        FirstName: this.userDetails.FirstName,
        LastName: this.userDetails.LastName,
        CountryCode: this.userDetails.CountryCode,
        Mobile: this.userDetails.Mobile,
        Gender: this.userDetails.Gender,
        Email: this.userDetails.Email
      };
      console.log("update payload :", payload);
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/UpdateProfile", "POST", token, payload).then(function (result) {
        console.log(result.res.data.Status);
        if (result.res.data.Status) {
          if (result.res.data.hasOwnProperty("verify") && result.res.data.verify) {
            _this3.$refs.OTPModal.show();
          }
          _this3.$toasted.show("Profile has been updated successfully");
          setTimeout(function () {
            _this3.$toasted.clear();
          }, 5000);
        } else {
          _this3.userDetails = _this3._userDetails;

          _this3.errorMessage = result.res.data.Message;
        }
      }).catch(function (error) {
        _this3.userDetails = _this3._userDetails;
        console.log(_this3.userDetails);
        console.log(" Error", error);
      });
    },
    addPref: function addPref(data, type) {
      var _this4 = this;

      var payload = {
        ID: data.ID,
        PreferenceType: type,
        Active: data.selected == true ? 0 : 1
      };
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/AddPreferences", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;


        if (!error && res.data.Status) {
          _this4.getMyPref();
          // this.Genres=res.data.Genres
          // this.Languages=res.data.Languages
          // this.Events=res.data.Events
          // this.Sports=res.data.Sports
          console.log(res.data, "res.data.jitu");
          //this.countries = res.data.List;
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    getMyPref: function getMyPref() {
      var _this5 = this;

      this.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/GetPreferences", "POST", null, {}).then(function (response) {
        var error = response.error,
            res = response.res;


        if (!error && res.data.Status) {
          _this5.Genres = res.data.Genres;
          _this5.Languages = res.data.Languages;
          _this5.Events = res.data.Events;
          _this5.Sports = res.data.Sports;
          console.log(res.data, "res.data.jitu");
          //this.countries = res.data.List;
        }
        _this5.hideLoading();
      }).catch(function (error) {
        _this5.hideLoading();
        console.log("Error", error);
        //   resolve(null);
      });
    }
  }
});

/***/ }),

/***/ 1212:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1213);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1036)("2ccc078b", content, true, {});

/***/ }),

/***/ 1213:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1035)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"userProfile3.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"OTPModal",attrs:{"id":"signIn","hide-header":"","hide-footer":"","centered":""}},[_c('div',{staticClass:"col-sm-9 col-md-10 mx-auto"},[_c('div',{staticClass:"modal-title"},[_vm._v("Verify your Deatils")]),_vm._v(" "),_c('form',{attrs:{"data-vv-scope":"signInVerifyOTP"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('signInVerifyOTP')}}},[_c('label',[_vm._v("- ENTER OTP -")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP),expression:"userDetails.OTP"}],attrs:{"name":"username","type":"text","placeholder":"OTP"},domProps:{"value":(_vm.userDetails.OTP)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "OTP", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"submit","value":"VERIFY OTP"},on:{"click":function($event){return _vm.verifyOTP()}}})])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper_mob"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-0"},[_c('b-tabs',{staticClass:"user-profile-tabs profile-tabs",attrs:{"content-class":""}},[_c('b-tab',{staticClass:"profile-details-edit",attrs:{"title":"Edit Profile","active":""}},[_c('div',{staticClass:"custom-shadow"},[_c('h4',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t("Edit Profile")))]),_vm._v(" "),_c('div',{staticClass:"row align-items-center justify-content-center"},[_c('div',{staticClass:"col-lg-6 mt-lg-4"},[_c('div',{},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.FirstName),expression:"userDetails.FirstName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"First Name"},domProps:{"value":(_vm.userDetails.FirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "FirstName", $event.target.value)}}})]),_vm._v(" "),_c('div',{},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.LastName),expression:"userDetails.LastName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Last Name"},domProps:{"value":(_vm.userDetails.LastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "LastName", $event.target.value)}}})]),_vm._v(" "),_c('div',{},[_c('b-form-group',[_c('b-form-radio-group',{attrs:{"id":"btn-radios-2","options":_vm.genderOptions,"buttons":"","button-variant":"outline-primary","size":"lg","name":"radio-btn-outline"},model:{value:(_vm.userDetails.Gender),callback:function ($$v) {_vm.$set(_vm.userDetails, "Gender", $$v)},expression:"userDetails.Gender"}})],1)],1),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"mobile-country-field"},[_c('div',{staticClass:"country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.userDetails.CountryCode == '0'
                              ? _vm.defaultCountryCode
                              : _vm.userDetails.CountryCode,"variant":"default"},slot:"append"},_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.CountryISOCode)+" ("+_vm._s(country.CountryName)+")")])}),1):_vm._e()],1),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.Mobile),expression:"userDetails.Mobile"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Mobile Number"},domProps:{"value":(_vm.userDetails.Mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "Mobile", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.Email),expression:"userDetails.Email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email","disabled":""},domProps:{"value":(_vm.userDetails.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "Email", $event.target.value)}}})]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"btn btn-pink",attrs:{"type":"submit"},on:{"click":function($event){return _vm.onUpdateProfile()}}},[_vm._v("\n                      Update\n                    ")])])])])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Preferences"}},[_c('div',{staticClass:"custom-shadow"},[_c('h6',{staticClass:"font-weight-bold"},[_vm._v("\n                  What do you Enjoy Watching?\n                ")]),_vm._v(" "),_c('div',{staticClass:"mt-3 mt-lg-5"},[_c('h6',{staticClass:"font-weight-bold"},[_vm._v("Genres")]),_vm._v(" "),_c('ul',{staticClass:"preference-list"},_vm._l((_vm.Genres),function(data,index){return _c('li',{key:index,staticClass:"d-flex align-items-center"},[_c('input',{attrs:{"type":"checkbox","id":data + index},domProps:{"checked":data.selected == true ? true : false},on:{"click":function($event){return _vm.addPref(data, 'Genres')}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":data + index}},[_vm._v("\n                        "+_vm._s(data.Label)+"\n                      ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"my-3 my-lg-5"},[_c('h6',{staticClass:"font-weight-bold"},[_vm._v("Languages")]),_vm._v(" "),_c('ul',{staticClass:"preference-list"},_vm._l((_vm.Languages),function(data,index){return _c('li',{key:index,staticClass:"d-flex align-items-center"},[_c('input',{attrs:{"type":"checkbox","id":data + index},domProps:{"checked":data.selected == true ? true : false},on:{"click":function($event){return _vm.addPref(data, 'Languages')}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":data + index}},[_vm._v("\n                        "+_vm._s(data.Label)+"\n                      ")])])}),0)])])])],1)],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.2229467af8744dba544d.js